import WholeNumberInput from 'components/WholeNumberInput';
import React, { useState } from 'react';
import { updateBagsOnOrder } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddBagTypesToOrder = props => {
  const { orderId, onSuccess, toggleModal } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [paperBag, setPaperBag] = useState<number>(0);
  const [plasticBag, setPlasticBag] = useState<number>(0);
  const [delicateItem, setDelicateItem] = useState<number>(0);

  const addOrderBags = async () => {
    setLoading(true);
    try {
      await updateBagsOnOrder({ id: orderId, bags: { paperBag, plasticBag, delicateItem } });
      await onSuccess();
      showSuccess('Order bags updated successfully.');
      toggleModal();
    } catch (e) {
      showError(e);
      setLoading(false);
    }
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Order</div>
            <div className={styles['modal-title']}>Add Bag Types</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Paper Bag</div>
            <WholeNumberInput value={paperBag} onChange={setPaperBag} disabled={false} />
          </div>
          <div>
            <div className={styles['label']}>Plastic Bag</div>
            <WholeNumberInput value={plasticBag} onChange={setPlasticBag} disabled={false} />
          </div>
          <div>
            <div className={styles['label']}>Delicate Items</div>
            <WholeNumberInput value={delicateItem} onChange={setDelicateItem} disabled={false} />
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={addOrderBags}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddBagTypesToOrder;
